/**
 * @file NetworkInformation
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/performance
 */
var _ref = typeof navigator !== 'undefined' && navigator.connection || {},
    _ref$type = _ref.type,
    nt = _ref$type === void 0 ? 'unknown' : _ref$type,
    _ref$effectiveType = _ref.effectiveType,
    net = _ref$effectiveType === void 0 ? '' : _ref$effectiveType,
    _ref$rtt = _ref.rtt,
    nrtt = _ref$rtt === void 0 ? 0 : _ref$rtt,
    _ref$downlinkMax = _ref.downlinkMax,
    ndlm = _ref$downlinkMax === void 0 ? 0 : _ref$downlinkMax,
    _ref$downlink = _ref.downlink,
    ndl = _ref$downlink === void 0 ? 0 : _ref$downlink;
/**
 * @name connection
 * @see https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
 */


export default {
  // network type
  nt: nt,
  // effectiveType
  net: net,
  // round-trip time
  nrtt: nrtt,
  // downlinkMax
  ndlm: ndlm,
  // downlink
  ndl: ndl
};